export default __webpack_public_path__ + "fonts/ionicons.b45d332f6829d68136006cdefeb2efe1.svg";